<svg width="48" height="28" viewBox="0 0 48 28" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="48" height="28" rx="4" fill="#FFFFFF" />
  <g transform="translate(11, 7)">
    <path d="M0 0h8.5l-2.5 14H0z" fill="#D81E06" />
    <path d="M7 0h8.5l-2.5 14H7z" fill="#004A97" />
    <path d="M14 0h8.5l-2.5 14h-8.5z" fill="#008238" />
    <text x="13" y="10" fill="#FFFFFF" font-size="5.5" font-weight="bold" font-family="sans-serif" text-anchor="middle">银联</text>
  </g>
</svg>
